import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../../context/AuthContext';
import { toast } from '../common/Toast/toast';
import FeedbackList from './FeedbackList.jsx';
import '../Trainer/TrainerDashboard.css';

/**
 * /session-feedback — every piece of session feedback, for staff.
 *
 * A page of its own rather than a tab on an existing dashboard: this is
 * the whole institution's teaching quality in one list, and it is read
 * deliberately rather than glanced at on the way somewhere else.
 *
 * The list underneath is scoped by the SERVER, so this same page is
 * correct for an administrator (everything, with names) and for anyone
 * else who can reach it (their own sessions, anonymised). Nothing here
 * asks who is looking.
 */
const SessionFeedback = () => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (!hasPermission('list-attendance', 'view', 'lms')) {
      if (!hasShownToast.current) {
        hasShownToast.current = true;
        toast.error('You do not have permission to view session feedback.');
        navigate('/');
      }
    }
  }, [hasPermission, navigate]);

  return (
    <div className="pg">
      <header className="pg-head">
        <div className="pg-head-main">
          <h4 className="pg-title">Session feedback</h4>
          <p className="pg-sub">
            What students said about the classes they attended — the session,
            its topics one by one, and the trainer.
          </p>
        </div>
      </header>

      <FeedbackList variant="page" />
    </div>
  );
};

export default SessionFeedback;
